import * as React from 'react';
import { VISA, MASTERCARD, AMEX } from '../payments/Constants';
import { CreditCardType } from '../payments/Types';
import { Icon_Visa, Icon_MasterCard, Icon_AmericanExpress } from 'material-ui-credit-card-icons';
import * as creditcardutils from 'creditcardutils';

export const renderCreditCardIcon = (creditcardType: CreditCardType): JSX.Element => {
  switch (creditcardType) {
    case VISA:
      return(
        <div>
          <Icon_Visa style={{position: 'absolute', right: 20, top: 40, width: 20, height: 20}}/>
        </div>
      );
    case MASTERCARD:
      return(
        <div>
          <Icon_MasterCard style={{position: 'absolute', right: 45, top: 40, width: 20, height: 20}}/>
        </div>
      );
    case AMEX:
      return(
        <Icon_AmericanExpress style={{position: 'absolute', right: 70, top: 40, width: 20, height: 20}}/>
      );
    default:
      return(
        <div>
          <Icon_Visa style={{position: 'absolute', right: 20, top: 40, width: 20, height: 20}}/>
          <Icon_MasterCard style={{position: 'absolute', right: 45, top: 40, width: 20, height: 20}}/>
          <Icon_AmericanExpress style={{position: 'absolute', right: 70, top: 40, width: 20, height: 20}}/>
        </div>
      );
  }
};

export const parseCreditCardType = (input: string): CreditCardType =>
  creditcardutils.parseCardType(creditcardutils.formatCardNumber(input)).toUpperCase();


// WEBPACK FOOTER //
// ./src/creditcard/CreditCardIconHelper.tsx